import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Flex, Form } from 'antd';
import { FormProps } from 'antd/lib';
import { Rule } from 'antd/lib/form';
import { SelectProps } from 'antd/lib/select';
import { ReactNode } from 'react';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import CompanyContactInfoModal from '@/components/general/CompanyContactInfoModal';

/**
 * Campo selector de empresa con botón de información de contacto integrado.
 * Encapsula el patrón repetido de Form.Item + Flex + AntdSelect + CompanyContactInfoModal.
 *
 * metadata:
 * - feature: forms.company-select-field
 * - purpose: elimina la duplicación del selector de empresa con botón info presente en
 *   TicketForm, ReceptionDetailForm, ShipmentDetailForm y ShipmentPaymentForm
 */
interface CompanySelectFieldProps {
  /** Nombre del campo en el formulario */
  name: string;
  /** Label del campo */
  label: ReactNode;
  /** Props del selector de empresa */
  selectProps: SelectProps;
  /** Reglas de validación */
  rules?: Rule[];
  /** FormProps para obtener la instancia del form y hacer watch */
  formProps: FormProps;
  /** Si se marca como required (muestra asterisco) */
  required?: boolean;
  /** Callback onChange personalizado que se ejecuta además del onChange del selectProps */
  onChange?: (value: any, option: any) => void;
  /** Clase CSS adicional */
  className?: string;
}

const CompanySelectField = ({
  name,
  label,
  selectProps,
  rules,
  formProps,
  required = false,
  onChange,
  className,
}: CompanySelectFieldProps) => {
  const company = Form.useWatch(name, formProps.form);

  return (
    <Form.Item label={label} required={required} className={className}>
      <Flex align="center" gap={4}>
        <Form.Item name={name} rules={rules} noStyle>
          {/* CompanySelector comentado – pendiente de migración */}
          <AntdSelect
            {...selectProps}
            allowClear
            showSearch
            onChange={(v, opt) => {
              selectProps?.onChange?.(v, opt);
              onChange?.(v, opt);
            }}
          />
        </Form.Item>
        {company && (
          <CompanyContactInfoModal
            company={company}
            openButton={<Button icon={<InfoCircleOutlined />} />}
          />
        )}
      </Flex>
    </Form.Item>
  );
};

export default CompanySelectField;
